module.exports = __webpack_public_path__ + "static/img/applepay.e062e61b.svg";